<template lang="pug">
	.audio-tracker--exact-length-tool
		Popup(v-if="popupVisible", :popupVisible.sync="popupVisible", :title="$tCaption('Make exact length')", :width="260", :height="400", classes="tracker-dark", :autosize="true")
			.flex-col.space-medium
				.flex-col.space
					span {{$tCaption('Target length (seconds)')}}
					DxNumberBox(:value.sync="targetLength", :min="minLength", :max="maxLength", :showSpinButtons="true", stylingMode="filled")
				.flex-col.space(v-if="!isSSML")
					span {{$tCaption('Mix fade (seconds)')}}
					DxNumberBox(:value.sync="mixFade", :showSpinButtons="true", stylingMode="filled")
				.flex-col.space(v-if="!isSSML")
					span {{$tCaption('Trim silence (db)')}}
					DxNumberBox(:value.sync="trimSilence", :showSpinButtons="true", stylingMode="filled")
			template(slot="actions-right")
				DxButton(:text="$tCaption('Cancel', '@actions')", @click="popupVisible = false", :disabled="processing")
				DxButton(:text="$tCaption('Apply', '@actions')", @click="apply", type="default", :disabled="processing")
</template>

<script>
	import Popup from 'app-core/Popup.vue';
	import DxNumberBox from 'devextreme-vue/number-box';
	import DxButton from 'devextreme-vue/button';
	import { calcExactLength } from './audio-helper';

	export default {
		translationCategory: 'audioTracker.AudioTrackerExactWidthTool',
		name: 'audio-tracker--exact-length-tool',
		components: { Popup, DxNumberBox, DxButton },
		props: ['track', 'tracker'],
		data() {
			return {
				popupVisible: false,
				targetLength: 0,
				mixFade: 0.3,
				trimSilence: -50,
				processing: false
			};
		},
		computed: {
			isSSML() {
				return this.track.type === 'textToSpeech';
			},
			sourceLength() {
				return this.track.duration * this.track.insertion.Rate || this.track.duration;
			},
			minLength() {
				return this.isSSML ? this.sourceLength * 0.5 : 1;
			},
			maxLength() {
				return this.isSSML ? this.sourceLength * 2 : this.sourceLength;
			}
		},
		watch: {
		},
		mounted() {
			if (__DEBUG__)
				window.exactWidthTool = this;
		},
		methods: {
			show() {
				this.targetLength = Math.round(this.track.duration);
				this.popupVisible = false;
				setImmediate(() => {
					this.popupVisible = true;
				});
			},
			async apply() {
				try {
					this.processing = true;
					if (this.isSSML) {
						await this.processSSMLTrack();
					} else {
						await this.processAudioTrack();
					}
				} finally {
					this.processing = false;
				}
			},
			async processAudioTrack() {
				let fadeSeconds = this.mixFade;
				const fadeOut = 0.5;
				const exactLengthInfo = await calcExactLength(this.track.__buffer, this.track.__bpmInfo, { 
					targetLength: this.targetLength,
					trimSilence: this.trimSilence,
					fadeOut
				});
				const playbackRate = exactLengthInfo.playbackRate;
				
				this.track.endOffset = Math.min(this.track.duration - 1, exactLengthInfo.left.endOffset);
				this.track.insertion.JsonConfig.fadeOut = {
					type: 'linear',
					value: Math.min(fadeSeconds, this.track.getTrimmedDuration() - 0.1)
				}
				this.track.playbackRate = playbackRate;
				this.track.startOffset = exactLengthInfo.left.startOffset;

				this.track.__duplicate(this.track, true, {
					StartTime: parseInt((this.track.start + this.track.getTrimmedDuration()) * 1000),
					EndOffset: parseInt(exactLengthInfo.right.endOffset * 1000),
					Duration: parseInt(exactLengthInfo.right.duration * 1000),
					StartOffset: parseInt(exactLengthInfo.right.startOffset * 1000),
					JsonConfig: {
						fadeIn: {
							type: 'linear',
							value: fadeSeconds
						},
						fadeOut: {
							type: 'linear',
							value: fadeOut
						},
						overlappingMode: 'sourceAudible',
						playbackRate
					}
				});

				this.track.endOffset = Math.max(0, this.track.endOffset - fadeSeconds / playbackRate);

				this.popupVisible = false;
			},
			async processSSMLTrack() {
				const rate = this.sourceLength / this.targetLength * 0.965;
				this.track.insertion.Rate = rate;
				this.track.__saveInsertion();
				this.track.__regenerate();
				this.popupVisible = false;
			}
		}
	};
</script>
<style lang='scss'>
	@import "main/themes/generated/variables.base.scss";

	.audio-tracker--exact-length-tool {
		
	}
</style>
